import {DiaryEvent} from "@feature/diary";
import {EventStatus} from "@feature/diary";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class DiaryEventStatusProvider {
  getDatedEventStatus(event: DiaryEvent): EventStatus {
    if (event.DateCompleted) {
      return EventStatus.Completed;
    }
    else if (event.EventDatePassed ) {
      return EventStatus.EventDatePassed;
    }
    else if (event.NoticeDatePassed) {
      return EventStatus.NoticeDatePassed;
    }
    else {
      return EventStatus.None;
    }
  }

  getUndatedEventStatus(event: DiaryEvent):EventStatus {
    const currentDate = new Date();
    if (event.DateCompleted) {
      return EventStatus.Completed;
    }
    else if (event.EventDatePassed && event.NoticeServedDate) {
      return EventStatus.EventDatePassed;
    }
    else if(event.NoticeServedDate && new Date(event.EventDate) > currentDate) {
      return EventStatus.NoticeServed;
    }
    else if(event.UDOStartDate && new Date(event.UDOStartDate) > currentDate) {
      return EventStatus.NotStarted;
    }
    else if(new Date(event.UDOStartDate) <= currentDate && new Date(event.UDOEndDate) >= currentDate) {
      return EventStatus.Current;
    }
    else if(event.UDOEndDate && new Date(event.UDOEndDate) < currentDate) {
      return EventStatus.Ended;
    }
    else {
      return EventStatus.None;
    }
  }
}
